import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navigation.css';

const Navigation: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          Two Him
        </Link>
        <div className="nav-links">
          <Link to="/browse">Browse</Link>
          <Link to="/hashtags">Hashtags</Link>
          <Link to="/leaderboards">🏆 Leaderboards</Link>
          <Link to="/matches">Matches</Link>
          <Link to="/referrals">🎁 Referrals</Link>
          <Link to="/profile">Profile</Link>
          <button onClick={handleLogout} className="logout-btn">
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
